<template>
  <div class="funnel-card" @click="$emit('open', funnel)">
    <div class="funnel-card-header">
      <div class="funnel-card-icon">
        <i class="fa-solid fa-clone"></i>
      </div>
      <div class="funnel-card-info">
        <span class="funnel-card-name">{{ funnel.name }}</span>
        <span v-if="funnel.description" class="funnel-card-description">{{ funnel.description }}</span>
      </div>
    </div>

    <div v-if="funnel.allowedUsers" class="funnel-card-users" v-html="funnel.allowedUsers"></div>

    <div class="funnel-card-actions">
      <span v-b-tooltip.hover title="Total de Cards" class="funnel-card-total-cards">
        <i class="fa-solid fa-layer-group"></i>
        {{ funnel.totalCards || 0 }}
      </span>

      <div class="funnel-card-buttons">
        <div
          v-b-tooltip.hover
          title="Ver Quadro"
          class="funnel-card-btn"
          @click.stop="$emit('open', funnel)"
        >
          <i class="fa-solid fa-chart-kanban"></i>
        </div>
        <div
          v-b-tooltip.hover
          title="Editar Quadro"
          class="funnel-card-btn"
          @click.stop="$emit('edit', funnel)"
        >
          <i class="fa-solid fa-pen-to-square"></i>
        </div>
        <div
          v-b-tooltip.hover
          title="Excluir Quadro"
          class="funnel-card-btn funnel-card-btn-danger"
          @click.stop="$emit('delete', funnel)"
        >
          <i class="fa-solid fa-trash"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FunnelCard",
  props: {
    funnel: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>

.funnel-card {
  background: var(--bg-base);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  width: 320px;
  padding: 16px 20px;
  cursor: pointer;
  transition: box-shadow 0.15s, border-color 0.15s, transform 0.15s;
}

.funnel-card:hover {
  box-shadow: var(--shadow-sm);
  transform: translateY(-1px);
}

.funnel-card-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.funnel-card-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(87, 118, 150, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-brand);
  font-size: 16px;
  flex-shrink: 0;
}

.funnel-card-user {
  margin-left: -10px;
}

.funnel-card-img-user {
  width: 30px;
  height: 30px;
  border-radius: 100px;
}

.funnel-card-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.funnel-card-name {
  font-size: 15px;
  font-weight: 500;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

.funnel-card-description {
  font-size: 12px;
  color: var(--text-muted);
  font-style: italic;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

.funnel-card-users {
  margin-bottom: 12px;
  min-height: 20px;
}

.funnel-card-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  border-top: 1px solid var(--border-subtle);
}

.funnel-card-total-cards {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 999px;
  background: var(--bg-elevated);
  color: var(--text-secondary);
  font-size: 12px;
  font-weight: 600;
}

.funnel-card-buttons {
  display: flex;
  align-items: center;
  gap: 14px;
}

.funnel-card-btn {
  font-size: 16px;
  cursor: pointer;
  color: var(--text-muted);
  transition: color 0.15s;
}

.funnel-card-btn:hover {
  color: var(--color-brand);
}

.funnel-card-btn-danger {
  color: var(--color-danger);
}

.funnel-card-btn-danger:hover {
  color: var(--color-danger);
}
</style>

